import { FrontTicketPurchaseOfferResponseDto } from '@/lib/jp-api/requests';
import { getClientLanguage } from '@/lib/get-client-language';

const discountPercentageFormatter = new Intl.NumberFormat(getClientLanguage(), {
  style: 'percent',
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

export function getDiscountLabel(baseOffer: FrontTicketPurchaseOfferResponseDto, offer: FrontTicketPurchaseOfferResponseDto): string {
  if (offer.discount) return offer.discount;
  const basePrice = Number(baseOffer.price) / baseOffer.minimumAmount;
  const discount =
    offer.pricingModel === 'fixed'
      ? (basePrice - Number(offer.price) / offer.minimumAmount) / basePrice
      : Number(offer.discountPercentage) / 100;
  return discountPercentageFormatter.format(discount) + ' off';
}
